import { useState } from 'react';

const SelectNew = props => {
  const { placeholder, value, onChange, name, className } = props;

  const options = [
    {
      label: '1',
      value: '1',
    },
    {
      label: '2',
      value: '2',
    },
    {
      label: '3',
      value: '3',
    },
  ];

  const [isOpen, setIsOpen] = useState(false);

  const handleOptionClick = option => {
    onChange({ target: { name, value: option } });
    setIsOpen(false);
  };

  return (
    <div className={`relative ${className}`}>
      <div
        className="flex h-[56px] w-full cursor-pointer items-center justify-between rounded-[5px] border border-blue bg-white px-[27px] py-[2px] shadow-[0px_4px_6.9px_0px_#26262817]"
        onClick={() => setIsOpen(!isOpen)}
      >
        <p className="flex flex-nowrap font-[500] leading-[20px] text-[#000000] :text-[16px]">{value ? value : placeholder}</p>

        <svg
          width="14"
          height="8"
          viewBox="0 0 14 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        >
          <path
            d="M1.51335 0.0771479L0.333353 1.25715L7.00002 7.92381L13.6667 1.25715L12.4867 0.0771484L7.00002 5.56381L1.51335 0.0771479Z"
            fill="#000000"
          />
        </svg>
      </div>

      {isOpen && (
        <ul className="absolute right-0 top-[52px] w-full rounded-[5px] bg-white shadow-md md:top-[60px] z-20">
          {options.map(option => (
            <li
              key={option.value}
              className="flex items-center justify-between cursor-pointer text-[16px] px-[16px] py-[14px]"
              onClick={() => handleOptionClick(option.label)}
            >
              <span>{option.label}</span>
              {value === option.label && (
                <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.6667 1L4.33333 8.33333L1 5" stroke="#09AF77" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SelectNew;
